import { bootstrapApplication } from '@angular/platform-browser';
import { importProvidersFrom } from '@angular/core';
import { AppComponent } from './app/app.component';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LOCALE_ID } from '@angular/core';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';

import { appRoutes } from './app/app.routes';
import { SharedModule, APP_DOMAIN } from '@metallgehalt/shared';
import { TvoedSalaryModule } from './app/tvoed-salary-calculator/tvoed-salary.module';
import { BruttoNettoModule } from './app/brutto-netto-calculator/brutto-netto.module';
import { registerLocaleData } from '@angular/common';

registerLocaleData(localeDe, 'de-DE', localeDeExtra);

function bootstrap() {
  bootstrapApplication(AppComponent, {
    providers: [
      importProvidersFrom(
        BrowserModule,
        HttpClientModule,
        RouterModule.forRoot(appRoutes, { initialNavigation: 'enabledBlocking' }),
        BrowserAnimationsModule,
        SharedModule,
        TvoedSalaryModule,
        BruttoNettoModule
      ),
      { provide: LOCALE_ID, useValue: 'de-DE' },
      { provide: APP_DOMAIN, useValue: 'tvoedgehalt.de' }
    ]
  }).catch(err => console.error(err));
}

if (document.readyState !== 'loading') {
  bootstrap();
} else {
  document.addEventListener('DOMContentLoaded', bootstrap);
}
